function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { Image } from "../../Image/Image/Image";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Container } from "../../Container/Container/Container";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { FocusedAtMidLine } from "../../Utility/FocusedAtMidLine";
import styles from "./NumberedStepsSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Step = function Step(_ref) {
  var number = _ref.number,
    headline = _ref.headline,
    description = _ref.description;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.step,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.circle,
      children: /*#__PURE__*/_jsx(FocusedAtMidLine, {
        atMidLineClassName: styles.focusedAtMidLine,
        rootMargin: "0% 0% -50% 0%",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.stepNumber,
          children: number
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.stepContent,
      children: [/*#__PURE__*/_jsx(HeadingText, {
        className: styles.stepHeadline,
        align: "left",
        typog: "subhead3",
        children: headline
      }), /*#__PURE__*/_jsx(Text, {
        richText: true,
        align: "left",
        typog: "bodycopy",
        children: description
      })]
    })]
  });
};
export var NumberedStepsSlice = function NumberedStepsSlice(_ref2) {
  var headline = _ref2.headline,
    image = _ref2.image,
    steps = _ref2.steps;
  return /*#__PURE__*/_jsxs(Container, {
    children: [headline && /*#__PURE__*/_jsx(HeadingText, {
      className: styles.headline,
      align: headline.align,
      ariaLevel: headline.ariaLevel,
      typog: headline.typog || 'headline4',
      children: headline.text
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.columns,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.imageContainer,
        children: (image === null || image === void 0 ? void 0 : image.mobile) && image.desktop && /*#__PURE__*/_jsxs(Breakpoint, {
          breakpoint: "small",
          children: [/*#__PURE__*/_jsx(Image, _objectSpread({
            className: styles.image
          }, image.mobile)), /*#__PURE__*/_jsx(Image, _objectSpread({
            className: styles.image
          }, image.desktop))]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.steps,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.stepsInner,
          children: steps === null || steps === void 0 ? void 0 : steps.map(function (step, index) {
            return /*#__PURE__*/_jsx(Step, _objectSpread({}, step), "step-".concat(index));
          })
        })
      })]
    })]
  });
};